import { get, post } from '@/utils/request'

/**
 * 获取所有大屏数据
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 */
export function getDashboardData(params) {
  return get('/api/dashboard/data', params)
}

/**
 * 获取日装机数据
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 */
export function getDailyInstalls(params) {
  return get('/api/dashboard/daily-installs', params)
}

/**
 * 获取日使用量数据
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 */
export function getDailyUsages(params) {
  return get('/api/dashboard/daily-usages', params)
}

/**
 * 获取月使用量数据
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 */
export function getMonthlyUsages(params) {
  return get('/api/dashboard/monthly-usages', params)
}

/**
 * 获取装机达标率
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 * @param {string} params.period - 周期 yearly（年度统计，基于本年度月均使用次数）
 */
export function getPassRates(params) {
  return get('/api/dashboard/pass-rates', params)
}

/**
 * 获取TOP10设备
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 * @param {string} params.period - 周期 daily/monthly
 */
export function getTop10Equipments(params) {
  return get('/api/dashboard/top10-equipments', params)
}

/**
 * 获取质控数据
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 * @param {string} params.period - 周期 daily/monthly
 */
export function getQualityControls(params) {
  return get('/api/dashboard/quality-controls', params)
}

/**
 * 获取概览数据
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 */
export function getOverview(params) {
  return get('/api/dashboard/overview', params)
}



/**
 * 获取各省装机数量（用于地图展示）
 * @param {Object} params - 查询参数
 * @param {string} params.areaCode - 区域代码（可选）
 */
export function getProvinceEquipmentCounts(params) {
  return get('/api/dashboard/province-equipment-counts', params)
}
